/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, FaMobile, FaPhotoVideo } from "react-icons/fa";

 

export const servicesData = [

    {
        id: 1,
        title: 'Web Development',
        icon: <BsCodeSlash />
    },
    {
        id: 2,
        title: 'Mobile App Development',
        icon: <FaMobile />
    },
    {
        id: 3,
        title: 'Graphic Design',
        icon: <FaPhotoVideo />
    },

]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.